import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import {zip, Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AuthenticationService } from '../services/authentification.service';
import {ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private router: Router, private translateService: TranslateService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401) {
        // auto logout if 401 response returned from api
        zip(
          this.translateService.get('SESSION_EXPIRED_TITLE'),
          this.translateService.get('SESSION_EXPIRED_MSG'),
          this.translateService.get('REQUEST_HANDLER_BTN')
        ).subscribe(
          msg => {
            Swal({
              html: `
            <h2>${msg[0]}</h2>
            <p class="m-b-10">${msg[1]}</p>
            `,
              allowOutsideClick: false,
              allowEscapeKey: false,
              width: '300px',
              allowEnterKey: false,
              confirmButtonText: msg[2],
              confirmButtonClass: 'btn btn-default',
              buttonsStyling: false,
              animation: false,
              customClass: 'my-animation payment-swal-response'
            }).then( () => {
              localStorage.removeItem('currentUser');
              this.authenticationService.currentUserSubject.next(null);
              location.reload(true);
            })
              .catch(Swal.noop);
          }
        );
      }
      if (err.status === 0) {
        // auto logout if 404 response returned from api
        localStorage.removeItem('currentUser');
        this.authenticationService.currentUserSubject.next(null);
        // this.router.navigate(['error']);
      }
      const error = err.error || err.statusText;
      return throwError(error);
    }));
  }
}
